import { api } from "@/lib/api/client";
import type {
  EmitterSummary,
  TaxDetailResponse,
  TaxListResponse,
  TaxConfig,
  TaxConfigResponse,
  TaxSummaryResponse,
} from "./types";

// Prefix /api/matrix (tax.routes montado en app.ts junto a matrixRoutes).

export const taxApi = {
  summary: async (): Promise<TaxSummaryResponse> => {
    const { data } = await api.get<TaxSummaryResponse>("/api/matrix/tax/summary");
    return data;
  },

  list: async (params: {
    status?: string;
    docType?: string;
    search?: string;
    page?: number;
    pageSize?: number;
  }): Promise<TaxListResponse> => {
    const { data } = await api.get<TaxListResponse>("/api/matrix/tax/documents", {
      params,
    });
    return data;
  },

  detail: async (id: number): Promise<TaxDetailResponse> => {
    const { data } = await api.get<TaxDetailResponse>(
      `/api/matrix/tax/documents/${id}`,
    );
    return data;
  },

  retry: async (id: number): Promise<{ message: string }> => {
    const { data } = await api.post(`/api/matrix/tax/documents/${id}/retry`);
    return data;
  },

  runEmitter: async (): Promise<{ message: string; summary: EmitterSummary }> => {
    const { data } = await api.post("/api/matrix/tax/run-emitter");
    return data;
  },

  /**
   * Devuelve una URL firmada de 15 min. No sirve el archivo por nuestro
   * backend: el bucket es privado y el signed URL evita proxear binarios.
   */
  downloadUrl: async (id: number, kind: "pdf" | "xml"): Promise<string> => {
    const { data } = await api.get<{ url: string }>(
      `/api/matrix/tax/documents/${id}/download`,
      { params: { kind } },
    );
    return data.url;
  },

  getConfig: async (): Promise<TaxConfigResponse> => {
    const { data } = await api.get<TaxConfigResponse>("/api/matrix/tax/config");
    return data;
  },

  updateConfig: async (body: {
    emisor: TaxConfig["emisor"];
    indServicio: number;
  }): Promise<{ config: TaxConfig }> => {
    const { data } = await api.put<{ config: TaxConfig }>("/api/matrix/tax/config", body);
    return data;
  },
};
